var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.offer.parts, function(part, partIndex) {
      return _c(
        "v-row",
        { key: part },
        [
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.departureRailDate"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.start_date,
                  callback: function($$v) {
                    _vm.$set(part, "start_date", $$v)
                  },
                  expression: "part.start_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.arrivalRailDate"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.end_date,
                  callback: function($$v) {
                    _vm.$set(part, "end_date", $$v)
                  },
                  expression: "part.end_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.class"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.seat_class,
                  callback: function($$v) {
                    _vm.$set(part, "seat_class", $$v)
                  },
                  expression: "part.seat_class"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.fromPlace"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.from,
                  callback: function($$v) {
                    _vm.$set(part, "from", $$v)
                  },
                  expression: "part.from"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.toPlace"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.to,
                  callback: function($$v) {
                    _vm.$set(part, "to", $$v)
                  },
                  expression: "part.to"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.carrier"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.carrier,
                  callback: function($$v) {
                    _vm.$set(part, "carrier", $$v)
                  },
                  expression: "part.carrier"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: _vm.$t("travelService.travelAgentComment"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.comment,
                  callback: function($$v) {
                    _vm.$set(part, "comment", $$v)
                  },
                  expression: "part.comment"
                }
              })
            ],
            1
          ),
          partIndex < _vm.offer.parts.length - 1
            ? _c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }